// Painel das tabelas do IBPT (Lei 12.741/2012). Só apresentação: as regras
// (vigência, aviso de 30 dias, UF do arquivo) são do backend.

export const ROTULO_SITUACAO = {
  vigente: 'Vigente',
  futura: 'Ainda não vigente',
  vencida: 'Vencida',
  desativada: 'Desativada',
};

// Cor do selo: vencendo em breve fica amarela mesmo vigente.
export function corSituacao(v) {
  if (!v) return '#888';
  if (v.situacao === 'vigente') return v.vence_em_breve ? '#b45309' : '#15803d';
  if (v.situacao === 'futura') return '#2563eb';
  return '#888';
}

// A prévia só pode ser confirmada sem erros e com o mesmo arquivo/UF da prévia.
export function podeConfirmar(previa, uf, arquivo) {
  return !!(previa && previa.ok && previa.sha256 && previa.uf === uf && arquivo
    && previa.arquivo_nome === arquivo.name);
}

export function fmtData(iso) {
  if (!iso) return '—';
  const [a, m, d] = String(iso).slice(0, 10).split('-');
  return `${d}/${m}/${a}`;
}

// Quadro "Pendências por empresa": a tabela do IBPT da UF não trava a emissão,
// mas aparece enquanto estiver pendente (sem tabela vigente) ou perto de vencer.
export function ibptPendente(p) {
  return !!p && ['pendente', 'vence_em_breve'].includes(p.ibpt);
}

export function rotuloIbpt(p) {
  if (!p || p.ibpt === 'ok') return 'Em dia';
  if (p.ibpt === 'pendente') return 'Pendente (notas saem sem o valor aproximado dos tributos)';
  if (p.ibpt === 'vence_em_breve') return `Vence em ${p.ibpt_dias} dia(s)`;
  if (p.ibpt === 'nao_se_aplica') return '— (MEI)';
  return 'Em dia';
}
